import { createSelector } from 'reselect';

// Selectors
import {
  makes,
  defaultMakeSelection
} from 'store/reducers/dealerSettings/selectors';
import { getQueryParams } from 'store/reducers/queryParams/selectors';
import {
  getLocaleCode,
  getLanguageCode
} from 'store/reducers/dealerLocale/selectors';

// Utils
import { getBrandLogoUrl } from 'utils/media';

export const getLocalizationStrings = state => state.localizationString;

export const getMessages = createSelector(
  getLocalizationStrings,
  getLanguageCode,
  (localizationString, languageCode) => {
    const messages = {};
    messages[languageCode] = { ...localizationString };
    return messages;
  }
);

export const getTranslate = createSelector(
  getLocalizationStrings,
  localizationStrings => key => localizationStrings[key]
);

const getLocalizationOverride = createSelector(
  getLocalizationStrings,
  localizationString => {
    if (localizationString) {
      const logoOverrideString =
        localizationString['c8.start.page.logo.override'];
      if (
        (logoOverrideString && logoOverrideString.trim() === '') ||
        logoOverrideString === 'none'
      ) {
        return '';
      } else {
        return logoOverrideString;
      }
    }
  }
);

export const dealerLogoURL = createSelector(
  getLocalizationOverride,
  makes,
  getQueryParams,
  defaultMakeSelection,
  getLocaleCode,
  (validLocalizationOverride, makes, queryParams, defaultMake, locale) => {
    if (makes && queryParams && locale) {
      if (validLocalizationOverride) {
        return validLocalizationOverride;
      }
      const validVariant =
        queryParams.variant &&
        makes.find(
          record =>
            record.variant &&
            record.variant.trim().toUpperCase() ===
              queryParams.variant.trim().toUpperCase()
        );
      if (validVariant) {
        return getBrandLogoUrl(validVariant.make, validVariant.variant, locale);
      }
      if (defaultMake) {
        const defaultVariant = makes.find(
          record =>
            record.make.trim().toUpperCase() ===
            defaultMake.trim().toUpperCase()
        );
        return getBrandLogoUrl(
          defaultVariant.make,
          defaultVariant.variant,
          locale
        );
      }
      return '';
    }
  }
);



// WEBPACK FOOTER //
// ./src/store/reducers/localizationString/selectors.js